import { useQuery } from '@tanstack/react-query'
import { getCategories } from '../api/categories'
import type { Category } from '@/types'

export const useCategories = () => {
  return useQuery<Category[]>({
    queryKey: ['categories'],
    queryFn: getCategories,
  })
}
